import MediaBanner from './media-banner';
export default MediaBanner;